import styled from 'styled-components';

export const StyledSideForm = styled.form`
  margin-top: 46px;
`;

export const StyledFormBody = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledFormLabel = styled.label`
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.8px;
  font-weight: 400;
`;

export const StyledFormRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFormLabelRequired = styled.span`
  color: #ff0000;
`;

export const StyledInput = styled.input`
  padding: 0 15px;
  background: #dedede;
  border: none;
  height: 38px;
  font-size: 14px;
  appearance: none;
  border-radius: 0;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 0 15px;
  background: #dedede;
  border: none;
  height: 38px;
  font-size: 14px;
  appearance: none;
  border-radius: 0;
`;

export const StyledTextarea = styled.textarea`
  padding: 5px 15px;
  background: #dedede;
  border: none;
  height: 38px;
  font-size: 14px;
  line-height: 26px;
  height: 77px;
`;

export const StyledFormCheckRow = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > a {
    margin-left: 11px;
    text-decoration: underline;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.8;
    text-align: left;
  }
`;
